import { mapGetters, mapActions } from 'vuex'

export const uploadWizardActions = {
  ...mapActions('uploadWizardStore', [
    'openUploadWizard',
    'closeUploadWizard',
    'goNext',
    'goBack',
    'setFiles',
    'removeFile',
    'getUploadPresignUrls',
    'uploadToS3',
    'updateFields',
    'setSelectedItems',
    'setCurrentItem',
    'setIsValidStepOne',
    'setExpirationDate',
    'updateDefaultFolder',
    'defaultFolderHasSet'
  ])
}

export const uploadWizardData = {
  ...mapGetters('uploadWizardStore', [
    'dialogUploadWizard',
    'steps',
    'wizardLength',
    'canGoNext',
    'wizardStep',
    'files',
    'fileHeaders',
    'isUploading',
    'selectedItems',
    'tipoDocumentos',
    'currentItem',
    'isValidStepOne',
    'isSetDefaultFolder',
    'expirationDate'
  ])
}
